import { Button, Col, Row } from "react-bootstrap";
import React from "react";
import { Link } from "react-router-dom";
import "./HomePage.css";
import PricingCards from "../PricingCard/PricingCards";
import { s3_url } from "common/constants";
import usePageTitle from "common/usePageTitle";

function HomePagePreparations() {
  usePageTitle("Naslovna");

  return (
    <div>
      <h1>Lumen@home - online pripreme za državnu maturu</h1>
      <hr />

      <Row className="mb-5">
        <Col md={3} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid"
            src={`${s3_url}/img/Karmen2.webp`}
            style={{ width: "100%" }}
            alt="Lumen@home"
            loading="lazy"
          />
        </Col>
        <Col md={6} className="d-flex align-items-center">
          <div>
            <h3>
              Tko je i što je <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              <em>Lumen@home</em> je web platforma za izvođenje priprema za
              ispite državne mature. Ideju o pripremama za ispite državne mature
              u virtualnom okruženju osmislila je vlasnica škole za poduke
              Lumen, Karmen Dasović. Karmen je profesorica matematike i fizike
              koja već 30 godina uspješno vodi školu za poduke Lumen. Njena
              ljubav prema poučavanju nastavnih sadržaja odvela ju je u razne
              projekte, pa tako trenutno i u virtualni svijet. Osmislila je za
              vas najbolji način usvajanja nastavnih sadržaja iz udobnosti
              vlastitog doma. Web platforma <em>Lumen@home</em> nudi vam
              pripreme za ispite državne mature iz matematike, fizike, kemije te
              hrvatskog i engleskog jezika. Cijeli projekt za vas će pripremiti
              i voditi njena dugogodišnja suradnica, Mia Černivec, mag.educ.
            </p>
          </div>
        </Col>
        <Col md={3} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-3"
            src={`${s3_url}/img/Prva_naslovna.webp`}
            style={{ width: "100%" }}
            alt="Lumen@home"
            loading="lazy"
          />
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col xs={12} sm={8} md={6} lg={4}>
          <Link to="/prijava-pripreme-drzavna-matura">
            <Button className="w-100">Prijavi se na pripreme!</Button>
          </Link>
        </Col>
      </Row>

      <Row className="my-5">
        <Col md={6} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/Mia.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
        <Col md={6} order={2} className="d-flex align-items-center">
          <div>
            <h3>
              Zašto odabrati pripreme na <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              Vama maturantima je posljednja godina srednjoškolskog obrazovanja
              veoma bitna, ali i veoma stresna i teška. Često u danu nemate
              dovoljno vremena usvajati sve nastavne sadržaje predmeta u školi,
              pripremati se za ispite državne mature, baviti se sportom, a opet
              nastojati raditi i sve ono što vas veseli i što volite. Upravo za
              vas s previše obaveza u danu <em>Lumen@home</em> je idealno
              rješenje. Nećete gubiti vrijeme na put do naše škole za poduke, mi
              ćemo doći u vaš dom i pomoći vam s učenjem.
            </p>
          </div>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col md={6} order={2} className="d-flex align-items-center">
          <div>
            <h3>
              Kako će se provoditi pripreme na <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              Pripreme za ispite državne mature održavat će se u fiksnim
              terminima, u trajanju od dva školska sata svakog tjedna. Kada se
              na našoj platformi prijavite za pripreme iz određenog predmeta,
              bit ćete dodani u grupu na platformi <em>Lumen@home</em>. Tamo
              ćete pronaći sve obavijesti i materijale koje je nastavnik
              pripremio za vas. Ogledne primjere naših materijala možeš
              pogledati{" "}
              <a
                href={`${s3_url}/samples/ogledni_primjerak_mat1.pdf`}
                target="_blank"
              >
                ovdje
              </a>{" "}
              i{" "}
              <a
                href={`${s3_url}/samples/ogledni_primjerak_mat2.pdf`}
                target="_blank"
              >
                ovdje
              </a>
              . Pripreme se provode putem videopoziva, u realnom vremenu, tako
              da ćeš imati mogućnost razgovarati s nastavnikom i postavljati
              pitanja ukoliko nastavni sadržaji ne budu jasni. Grupe započinju s
              radom sredinom siječnja 2024. godine.
            </p>
          </div>
        </Col>
        <Col md={6} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/računalo.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
      </Row>

      <Row className="mb-5">
        <Col md={6} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/kem_maria.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
        <Col md={6} order={2} className="d-flex align-items-center">
          <div>
            <h3>Koliko će pristupnika imati svaka grupa?</h3>
            <p className="lead">
              Želimo održati kvalitetu našeg rada i u virtualnom okruženju pa će
              grupe biti male, 10 – 14 učenika.
            </p>
            <h3>
              Tko će voditi pripreme na <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              Pripreme vode naši dugogodišnji suradnici s višegodišnjim
              iskustvom rada u školi, kao i vođenju priprema za ispite državne
              mature. Upoznati naše nastavnike možeš na izbornoj traci, gumb
              nastavnici.
            </p>
            <h3>
              Kako se prijaviti na pripreme na <em>Lumen@home</em>?
            </h3>
            <p className="lead">
              Prijava je vrlo jednostavna. Prvo morate ispuniti prijavnicu za
              pripreme koja se nalazi na crvenim gumbima na naslovnoj stranici
              ili na izbornoj traci platforme <em>Prijava Priprema</em>. Ubrzo
              će vam biti dodijeljena grupa za predmete na koje ste se prijavili
              i tada ćete kreirati vlastiti račun kojim ćete se prijavljivati u
              aplikaciju <em>Lumen@home</em>. Tamo vas čekaju obavijesti i radni
              materijali. Ukoliko imaš dodatnih pitanja možeš nam se obratiti na{" "}
              <a href="mailto:mia@lumenathome.com">mia@lumenathome.com</a> ili{" "}
              <a href="tel:+38598257119"> 098 257 119.</a>
            </p>
          </div>
        </Col>
      </Row>

      <h3 className="text-center">
        Grupe priprema za maturu na <em>Lumen@home</em>
      </h3>

      <PricingCards />

      <h3 className="text-center mb-5">
        Nemoj previše čekati, grupe se brzo pune!
        <Link to="/prijava-pripreme-drzavna-matura">
          <Button className="px-4 m-3">Prijavi se i ti!</Button>
        </Link>
      </h3>
    </div>
  );
}

export default HomePagePreparations;
